module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }